import React, { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import { Tab, Tabs } from 'react-bootstrap';

import GoBackButton from '../../../components/GoBackButton';
import useFetchApi from '../../../customHooks/useFetchApi';
import PreCanCVs1 from './PreCanCVs1';
import PreCanCVs2 from './PreCanCVs2';

const ConCanCVs = () => {
    const { id } = useParams();
    const componentRef = useRef();
    const [template, setTemplate] = useState('t1');
    const { data: candidate } = useFetchApi({ 'url': `candidate-view/?id=${id}` });

    return (
        <div className='p-5'>
            <GoBackButton />
            <Tabs defaultActiveKey="t1" className="mb-3" onSelect={key => setTemplate(key)}>
                <Tab eventKey="t1" title="Template 1">
                    <PreCanCVs1 candidate={candidate} ref={template === 't1' ? componentRef : null} />
                </Tab>
                <Tab eventKey="t2" title="Template 2">
                    <PreCanCVs2 candidate={candidate} ref={template === 't2' ? componentRef : null} />
                </Tab>
            </Tabs>
            <div className="text-right">
                <ReactToPrint
                    content={() => componentRef.current}
                    trigger={() => <button className="btn btn-primary">Print to PDF!</button>}
                />
            </div>
        </div>
    );
};

export default ConCanCVs;
